/**
 * DTO întors de GET /dashboard/bookings-summary.
 * Coloanele UI sunt fixate: Ref + containere desc, Firmă, Rută POL→POD, Navă,
 * ETD, ETA, Preț (USD), Status (id din claudeMockData.CONTAINER_STATUSES).
 */
export interface BookingSummaryRow {
  id: number;
  ref: string;
  /** Descriere agregată: ex. "2 × 40HC, 1 × 20DV". */
  containersSummary: string;
  containerCount: number;
  companyName: string;
  companyId: number;
  pol: string;
  pod: string;
  vesselName: string;
  /** ISO string sau null. */
  etd: string | null;
  /** Data On Board (booking.onBoardDate), ISO string sau null. */
  onBoardDate?: string | null;
  /** ISO string sau null. */
  eta: string | null;
  /** in_transit | transshipment | black_sea | discharged | in_delivery | completed */
  status: string;
}

export const EMPTY_BOOKINGS_SUMMARY: BookingSummaryRow[] = [];
